export const DetailedClaimConditionsDread = [
    {
        value: 'Accidental HIV - Proof of accidental contraction HIV as per policy document',
        label: 'Accidental HIV - Proof of accidental contraction HIV as per policy document',
        Category: 'HIV/AIDS - Proof of accidental contraction HIV as per policy document',
    },
    {
        value: 'AIDS - Proof of clinical manifestation of AIDS as per policy document',
        label: 'AIDS - Proof of clinical manifestation of AIDS as per policy document',
        Category: 'HIV/AIDS - Proof of clinical manifestation of AIDS as per policy document',
    },
    {
        value:
            "Alzheimer's disease - On diagnosis of Alzheimers disease or progressive dementia in accordance with the latest version of the DSM criteria.",
        label:
            "Alzheimer's disease - On diagnosis of Alzheimers disease or progressive dementia in accordance with the latest version of the DSM criteria.",
        Category:
            "Alzheimer's disease - On diagnosis of Alzheimers disease or progressive dementia",
    },
    {
        value:
            'Aneurysm - Endovascular surgery or stent to repair any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal iliac and ileofemoral arteries',
        label:
            'Aneurysm - Endovascular surgery or stent to repair any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal iliac and ileofemoral arteries',
        Category:
            'Aneurysm - Endovascular surgery or stent to repair any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal iliac and ileofemoral arteries',
    },
    {
        value: 'Aneurysm - Endovascular surgery or stent to repair any aortic aneurysm',
        label: 'Aneurysm - Endovascular surgery or stent to repair any aortic aneurysm',
        Category: 'Aneurysm - Endovascular surgery or stent to repair any aortic aneurysm',
    },
    {
        value:
            'Aneurysm - Surgery (including bypass graft or keyhole surgery) to repair an aneurysm dissection or a narrowing of the thoracic or abdominal aorta',
        label:
            'Aneurysm - Surgery (including bypass graft or keyhole surgery) to repair an aneurysm dissection or a narrowing of the thoracic or abdominal aorta',
        Category:
            'Aneurysm - Surgery (including bypass graft or keyhole surgery) to repair an aneurysm dissection or a narrowing of the thoracic or abdominal aorta',
    },
    {
        value:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of an ileofemoral aneurysm',
        label:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of an ileofemoral aneurysm',
        Category:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of an ileofemoral aneurysm',
    },
    {
        value:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal and iliac arteries',
        label:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal and iliac arteries',
        Category:
            'Aneurysm - Surgical repairs (including bypass graft or keyhole surgery) of any aneurysm of the following branches of the aorta: subclavian brachiocephalic splenic renal and iliac arteries',
    },
    {
        value: 'Aplastic anaemia and other blood disorders - A bone marrow transplantation',
        label: 'Aplastic anaemia and other blood disorders - A bone marrow transplantation',
        Category: 'Aplastic anaemia and other blood disorders - A bone marrow transplantation',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - Aplastic anaemia and other blood disorders requiring repeated blood or blood product transfusion (at least four units of blood or blood products per month for at least 3 months) with at least one month of the schedule already adhered to.',
        label:
            'Aplastic anaemia and other blood disorders - Aplastic anaemia and other blood disorders requiring repeated blood or blood product transfusion (at least four units of blood or blood products per month for at least 3 months) with at least one month of the schedule already adhered to.',
        Category:
            'Aplastic anaemia and other blood disorders - Aplastic anaemia and other blood disorders requiring repeated blood or blood product transfusion',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - Confirmed diagnosis of aplastic anaemia/bone marrow aplasia',
        label:
            'Aplastic anaemia and other blood disorders - Confirmed diagnosis of aplastic anaemia/bone marrow aplasia',
        Category:
            'Aplastic anaemia and other blood disorders - Aplastic anaemia/bone marrow aplasia',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome coring 2.5 or higher on International Prognostic Scoring System (IPPS)',
        label:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome coring 2.5 or higher on International Prognostic Scoring System (IPPS)',
        Category:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome coring 2.5 or higher on International Prognostic Scoring System (IPPS)',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome requiring bone marrow transplant',
        label:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome requiring bone marrow transplant',
        Category:
            'Aplastic anaemia and other blood disorders - Myelodyplastic syndrome requiring bone marrow transplant',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - On diagnosis of Myeloproliferitive disorder (Polycythemia vera chronic myelogenous leukaemia essential thrombocythemia or myelofibrosis)',
        label:
            'Aplastic anaemia and other blood disorders - On diagnosis of Myeloproliferitive disorder (Polycythemia vera chronic myelogenous leukaemia essential thrombocythemia or myelofibrosis)',
        Category: 'Aplastic anaemia and other blood disorders - Myeloproliferitive disorder',
    },
    {
        value:
            'Aplastic anaemia and other blood disorders - Polycythemia vera with major organ failure',
        label:
            'Aplastic anaemia and other blood disorders - Polycythemia vera with major organ failure',
        Category:
            'Aplastic anaemia and other blood disorders - Polycythemia vera with major organ failure',
    },
    {
        value: 'Arrhythmia - Arrhythmia having undergone a defibrillator insertion',
        label: 'Arrhythmia - Arrhythmia having undergone a defibrillator insertion',
        Category: 'Arrhythmia - Arrhythmia having undergone a defibrillator insertion',
    },
    {
        value: 'Arrhythmia - Arrhythmia having undergone a permanent pacemaker insertion',
        label: 'Arrhythmia - Arrhythmia having undergone a permanent pacemaker insertion',
        Category: 'Arrhythmia - Arrhythmia having undergone a permanent pacemaker insertion',
    },
    {
        value: 'Arrhythmia - Arrhythmia having undergone pathway ablation',
        label: 'Arrhythmia - Arrhythmia having undergone pathway ablation',
        Category: 'Arrhythmia - Arrhythmia having undergone pathway ablation',
    },
    {
        value:
            'Arrhythmia - Intravenous inotropic support for more than 2 days. (Note that for this benefit claims may also be accepted under the Myocardial Infarction Cardiomyopathy or Pericardial diseases benefit categories instead of the Arrhythmias benefit category)',
        label:
            'Arrhythmia - Intravenous inotropic support for more than 2 days. (Note that for this benefit claims may also be accepted under the Myocardial Infarction Cardiomyopathy or Pericardial diseases benefit categories instead of the Arrhythmias benefit category)',
        Category: 'Arrhythmia - Intravenous inotropic support for more than 2 days',
    },
    {
        value: 'Arrhythmia - Permanent atrial fibrillation on optimal treatment',
        label: 'Arrhythmia - Permanent atrial fibrillation on optimal treatment',
        Category: 'Arrhythmia - Permanent atrial fibrillation on optimal treatment',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage I',
        label: 'BCC: Basal cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage I',
        label: 'BCC: Basal cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage II',
        label: 'BCC: Basal cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage II',
        label: 'BCC: Basal cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage III',
        label: 'BCC: Basal cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage III',
        label: 'BCC: Basal cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage IV',
        label: 'BCC: Basal cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage IV',
        label: 'BCC: Basal cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'Bladder cancer: Stage I',
        label: 'Bladder cancer: Stage I',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage I',
        label: 'Bladder cancer: Stage I',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage II',
        label: 'Bladder cancer: Stage II',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage II',
        label: 'Bladder cancer: Stage II',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage III',
        label: 'Bladder cancer: Stage III',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage III',
        label: 'Bladder cancer: Stage III',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage IV',
        label: 'Bladder cancer: Stage IV',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage IV',
        label: 'Bladder cancer: Stage IV',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        label: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        label: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        label: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        label: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        label: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        label: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Brain tumour: Grade 2 on WHO classification',
        label: 'Brain tumour: Grade 2 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 2 on WHO classification',
        label: 'Brain tumour: Grade 2 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 3 on WHO classification',
        label: 'Brain tumour: Grade 3 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 3 on WHO classification',
        label: 'Brain tumour: Grade 3 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 4 on WHO classification',
        label: 'Brain tumour: Grade 4 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 4 on WHO classification',
        label: 'Brain tumour: Grade 4 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        label:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        label:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage I',
        label: 'Breast cancer: Stage I',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage I',
        label: 'Breast cancer: Stage I',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage II',
        label: 'Breast cancer: Stage II',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage II',
        label: 'Breast cancer: Stage II',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage III',
        label: 'Breast cancer: Stage III',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage III',
        label: 'Breast cancer: Stage III',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage IV',
        label: 'Breast cancer: Stage IV',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage IV',
        label: 'Breast cancer: Stage IV',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        label:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        label:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Carcinoid: Carcinoid syndrome/tumour',
        label: 'Carcinoid: Carcinoid syndrome/tumour',
        Category: 'Cancer and leukaemia - Carcinoid',
    },
    {
        value: 'Carcinoid: Carcinoid syndrome/tumour',
        label: 'Carcinoid: Carcinoid syndrome/tumour',
        Category: 'Cancer and leukaemia - Carcinoid',
    },
    {
        value: 'Cardiomyopathy - A heart transplant: Cartdiomyopathy - A heart transplant',
        label: 'Cardiomyopathy - A heart transplant: Cartdiomyopathy - A heart transplant',
        Category: 'Cardiomyopathy - Heart transplant',
    },
    {
        value: 'Cardiomyopathy - But still NYHA class 3 (or METS< 5) and EF < 50%',
        label: 'Cardiomyopathy - But still NYHA class 3 (or METS< 5) and EF < 50%',
        Category:
            'Cardiomyopathy - Receiving optimal treatment (whether that is medical or surgical) for a cardiomyopathy',
    },
    {
        value: 'Cardiomyopathy - But still NYHA class 4 (or METS< 5) and EF < 50%',
        label: 'Cardiomyopathy - But still NYHA class 4 (or METS< 5) and EF < 50%',
        Category:
            'Cardiomyopathy - Receiving optimal treatment (whether that is medical or surgical) for a cardiomyopathy',
    },
    {
        value: 'Cardiomyopathy - But still NYHA class 4 (or METS< 3) and EF < 40%',
        label: 'Cardiomyopathy - But still NYHA class 4 (or METS< 3) and EF < 40%',
        Category:
            'Cardiomyopathy - Receiving optimal treatment (whether that is medical or surgical) for a cardiomyopathy',
    },
    {
        value:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as confirmed irreversible Cor Pulmonale',
        label:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as confirmed irreversible Cor Pulmonale',
        Category:
            'Cardio - Pulmonary dysfunction. Cardiopulmonary dysfunction resulting from or presenting as confirmed irreversible Cor Pulmonale',
    },
    {
        value:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as primary pulmonary hypertension',
        label:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as primary pulmonary hypertension',
        Category:
            'Cardio - Pulmonary dysfunction. Cardiopulmonary dysfunction resulting from or presenting as primary pulmonary hypertension',
    },
    {
        value:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as pulmonary venous occlusive disease',
        label:
            'Cardio - Pulmonary dysfunction: Cardiopulmonary dysfunction resulting from or presenting as pulmonary venous occlusive disease',
        Category:
            'Cardio - Pulmonary dysfunction. Cardiopulmonary dysfunction resulting from or presenting as pulmonary venous occlusive disease',
    },
    {
        value:
            'Carotid arterial disease - Angioplasty with or without stenting in both carotid arteries',
        label:
            'Carotid arterial disease - Angioplasty with or without stenting in both carotid arteries',
        Category:
            'Carotid arterial disease - Angioplasty with or without stenting in both carotid arteries',
    },
    {
        value:
            'Carotid arterial disease - Angioplasty with or without stenting in one carotid artery',
        label:
            'Carotid arterial disease - Angioplasty with or without stenting in one carotid artery',
        Category:
            'Carotid arterial disease - Angioplasty with or without stenting in one carotid artery',
    },
    {
        value: 'Carotid arterial disease - Bypass graft or endarterectomy in both carotid arteries',
        label: 'Carotid arterial disease - Bypass graft or endarterectomy in both carotid arteries',
        Category:
            'Carotid arterial disease - Bypass graft or endarterectomy in both carotid arteries',
    },
    {
        value: 'Carotid arterial disease - Bypass graft or endarterectomy in one carotid artery',
        label: 'Carotid arterial disease - Bypass graft or endarterectomy in one carotid artery',
        Category: 'Carotid arterial disease - Bypass graft or endarterectomy in one carotid artery',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - A stroke where there are residual symptoms or signs and a full recovery is not made',
        label:
            'Cerebrovascular incident (Stoke) - A stroke where there are residual symptoms or signs and a full recovery is not made',
        Category:
            'Cerebrovascular incident (Stoke) - A stroke where there are residual symptoms or signs and a full recovery is not made',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of 11% to 20%',
        label:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of 11% to 20%',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of 21% to 35%',
        label:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of 21% to 35%',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of greater than 35%',
        label:
            'Cerebrovascular incident (Stoke) - Measured by a Whole Person Impairment of greater than 35%',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by the permanent inability to independently perform activities of daily living scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Cerebrovascular incident (Stoke) - Measured by the permanent inability to independently perform activities of daily living scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by the permanent inability to independently perform activities of daily living scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Cerebrovascular incident (Stoke) - Measured by the permanent inability to independently perform activities of daily living scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - Measured by The permanent inability to independently perform activities of daily living scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Cerebrovascular incident (Stoke) - Measured by The permanent inability to independently perform activities of daily living scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment measured by',
    },
    {
        value:
            'Cerebrovascular incident (Stoke) - On diagnosis of a stroke as defined in the policy document',
        label:
            'Cerebrovascular incident (Stoke) - On diagnosis of a stroke as defined in the policy document',
        Category:
            'Cerebrovascular incident (Stoke) - On diagnosis of a stroke as defined in the policy document',
    },
    {
        value: 'Cerebrovascular incident (Stoke) - Stroke resulting in full recovery',
        label: 'Cerebrovascular incident (Stoke) - Stroke resulting in full recovery',
        Category: 'Cerebrovascular incident (Stoke) - Stroke resulting in full recovery',
    },
    {
        value: 'Cerebrovascular incident (Stoke) - Subarachnoid haemorrhage',
        label: 'Cerebrovascular incident (Stoke) - Subarachnoid haemorrhage',
        Category: 'Cerebrovascular incident (Stoke) - Subarachnoid haemorrhage',
    },
    {
        value: 'Cervical cancer: Stage I',
        label: 'Cervical cancer: Stage I',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage I',
        label: 'Cervical cancer: Stage I',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage II',
        label: 'Cervical cancer: Stage II',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage II',
        label: 'Cervical cancer: Stage II',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage III',
        label: 'Cervical cancer: Stage III',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage III',
        label: 'Cervical cancer: Stage III',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage IV',
        label: 'Cervical cancer: Stage IV',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage IV',
        label: 'Cervical cancer: Stage IV',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Chronic liver disorders - A liver transplant or total hepatectomy',
        label: 'Chronic liver disorders - A liver transplant or total hepatectomy',
        Category: 'Chronic liver disorders - A liver transplant or total hepatectomy',
    },
    {
        value: 'Chronic liver disorders - Endstage liver failure',
        label: 'Chronic liver disorders - Endstage liver failure',
        Category: 'Chronic liver disorders - Endstage liver failure',
    },
    {
        value: 'Chronic liver disorders - Fulminant hepatic necrosis',
        label: 'Chronic liver disorders - Fulminant hepatic necrosis',
        Category: 'Chronic liver disorders - Fulminant hepatic necrosis',
    },
    {
        value: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class A',
        label: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class A',
        Category: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class A',
    },
    {
        value: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class B',
        label: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class B',
        Category: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class B',
    },
    {
        value: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class C',
        label: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class C',
        Category: 'Chronic liver disorders - Liver dysfunction classified as ChildPugh class C',
    },
    {
        value:
            'Chronic liver disorders - On confirmed diagnosis of primary amyloidosis of the liver or spleen',
        label:
            'Chronic liver disorders - On confirmed diagnosis of primary amyloidosis of the liver or spleen',
        Category:
            'Chronic liver disorders - On confirmed diagnosis of primary amyloidosis of the liver or spleen',
    },
    {
        value: 'Chronic liver disorders - Partial hepatectomy due to disease',
        label: 'Chronic liver disorders - Partial hepatectomy due to disease',
        Category: 'Chronic liver disorders - Partial hepatectomy due to disease',
    },
    {
        value: 'Chronic liver disorders - Portal hypertesion',
        label: 'Chronic liver disorders - Portal hypertesion',
        Category: 'Chronic liver disorders - Portal hypertesion',
    },
    {
        value: 'Colorectal cancer: Stage I',
        label: 'Colorectal cancer: Stage I',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage I',
        label: 'Colorectal cancer: Stage I',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage II',
        label: 'Colorectal cancer: Stage II',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage II',
        label: 'Colorectal cancer: Stage II',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage III',
        label: 'Colorectal cancer: Stage III',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage III',
        label: 'Colorectal cancer: Stage III',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage IV',
        label: 'Colorectal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage IV',
        label: 'Colorectal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value:
            'Coma - Coma meeting the description in the policy document and the comatose state is persistent for longer than 96 hours',
        label:
            'Coma - Coma meeting the description in the policy document and the comatose state is persistent for longer than 96 hours',
        Category:
            'Coma - Coma meeting the description in the policy document and the comatose state is persistent for longer than 96 hours',
    },
    {
        value:
            'Coma - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Coma - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Coma - Coma meeting the description in the policy document and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Coma - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Coma - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Coma - Coma meeting the description in the policy document and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Coma - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Coma - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Coma - Coma meeting the description in the policy document and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
    },
    {
        value:
            'Unresponsive rheumatoid arthritis despite compliance with ongoing, continuous clinically accepted medical treatment with the following x-ray evidence of deformity of 3 or more large joints. X-ray evidence must show joint deformity',
        label:
            'Unresponsive rheumatoid arthritis despite compliance with ongoing, continuous clinically accepted medical treatment with the following x-ray evidence of deformity of 3 or more large joints. X-ray evidence must show joint deformity',
        Category: 'Rheumatoid Arthritis',
    },
    {
        value:
            'Sarcoidosis with evidence of permanent impairment of one of the following organ systems despite compliance with ongoing, continuous, clinically accepted medical treatment for at least 6 months (skin is excluded)',
        label:
            'Sarcoidosis with evidence of permanent impairment of one of the following organ systems despite compliance with ongoing, continuous, clinically accepted medical treatment for at least 6 months (skin is excluded)',
        Category: 'Sarcoidosis',
    },
    {
        value:
            'Progressive systemic scleroderma with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of at least one of the following organ systems',
        label:
            'Progressive systemic scleroderma with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of at least one of the following organ systems',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value:
            'Evidence of permanent severe dysphagia, nasal regurgitation and aspiration of liquids or semi-solid foods',
        label:
            'Evidence of permanent severe dysphagia, nasal regurgitation and aspiration of liquids or semi-solid foods',
        Category: 'Dermatomyositis and polymyositis',
    },
    {
        value:
            "Wegener's granulomatosis with permanent impairment of renal function (Glomerular filtration rate 30-60 ml/min)",
        label:
            "Wegener's granulomatosis with permanent impairment of renal function (Glomerular filtration rate 30-60 ml/min)",
        Category: "Wegener's granulomatosis",
    },
    {
        value:
            'Systemic lupus erythematosus (SLE) with evidence of SLE related Central Nervous System (CNS) vasculitis or permanent impairment of renal function (Glomerular filtration rate < 60ml/min)',
        label:
            'Systemic lupus erythematosus (SLE) with evidence of SLE related Central Nervous System (CNS) vasculitis or permanent impairment of renal function (Glomerular filtration rate < 60ml/min)',
        Category: 'Systemic lupus erythematosus (SLE)',
    },
    {
        value:
            "Wegener's granulomatosis with permanent impairment of renal function (Glomerular filtration rate < 30ml/min)",
        label:
            "Wegener's granulomatosis with permanent impairment of renal function (Glomerular filtration rate < 30ml/min)",
        Category: "Wegener's granulomatosis",
    },
    {
        value:
            'Unresponsive rheumatoid arthritis despite compliance with ongoing, continuous clinically accepted medical treatment having had any 1 of the following for a large joint:\r\nl Joint replacement\r\nl Joint fixation',
        label:
            'Unresponsive rheumatoid arthritis despite compliance with ongoing, continuous clinically accepted medical treatment having had any 1 of the following for a large joint:\r\nl Joint replacement\r\nl Joint fixation',
        Category: 'Rheumatoid Arthritis',
    },
    {
        value:
            'Sarcoidosis with evidence of permanent impairment of at least two of the following organ systems despite compliance with ongoing, continuous clinically accepted medical treatment',
        label:
            'Sarcoidosis with evidence of permanent impairment of at least two of the following organ systems despite compliance with ongoing, continuous clinically accepted medical treatment',
        Category: 'Sarcoidosis',
    },
    {
        value:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Dermatomyositis and polymyositis',
    },
    {
        value:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Polyarteritis nodosa',
    },
    {
        value:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Systemic Lupus erythematosus',
    },
    {
        value:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Unresponsive rheumatoid arthritis',
    },
    {
        value:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent, moderate impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value:
            'with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of at least two of the following organ systems',
        label:
            'with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of at least two of the following organ systems',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value:
            'With evidence of permanent impairment of all three of the following organ systems despite compliance with ongoing, continuous clinically accepted medical treatment',
        label:
            'With evidence of permanent impairment of all three of the following organ systems despite compliance with ongoing, continuous clinically accepted medical treatment',
        Category: 'Sarcoidosis',
    },
    {
        value:
            'with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of all three of the following organ systems',
        label:
            'with contractures of the fingers resulting in permanent, moderate impairment of self-care and movement categories (measured according to the Living Lifestyle Activities of Daily Living Table) AND evidence of permanent impairment despite compliance with ongoing, continuous clinically accepted medical treatment, of all three of the following organ systems',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        label:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        Category: 'Dermatomyositis and polymyositis',
    },
    {
        value:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        label:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        Category: 'Polyarteritis nodosa',
    },
    {
        value:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        label:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        Category: 'Systemic Lupus erythematosus',
    },
    {
        value:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        label:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        Category: 'Unresponsive rheumatoid arthritis',
    },
    {
        value:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        label:
            'Permanent severe impairment (that qualifies for 100% payout under a different benefit category) of major organs',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Dermatomyositis and polymyositis',
    },
    {
        value:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Polyarteritis nodosa',
    },
    {
        value:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Systemic Lupus erythematosus',
    },
    {
        value:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Unresponsive rheumatoid arthritis',
    },
    {
        value:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Permanent major impairment of both posture and motion and self-care and movement categories according to the Living Lifestyle Activities of Daily Living Table',
        Category: 'Progressive systemic scleroderma',
    },
    {
        value: 'Coronary artery disease - A heart transplant',
        label: 'Coronary artery disease - A heart transplant',
        Category: 'Coronary artery disease - Heart transplant',
    },
    {
        value: 'Coronary artery disease - Angioplasty with or without stenting',
        label: 'Coronary artery disease - Angioplasty with or without stenting',
        Category: 'Coronary artery disease - Angioplasty with or without stenting',
    },
    {
        value:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to any one coronary artery by means of a bypass graft',
        label:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to any one coronary artery by means of a bypass graft',
        Category:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to any one coronary artery by means of a bypass graft',
    },
    {
        value:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to three or more coronary arteries by means of a bypass graft',
        label:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to three or more coronary arteries by means of a bypass graft',
        Category:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to three or more coronary arteries by means of a bypass graft',
    },
    {
        value:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to two coronary arteries by means of a bypass graft',
        label:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to two coronary arteries by means of a bypass graft',
        Category:
            'Coronary artery disease - Surgery to correct the narrowing of or blockage to two coronary arteries by means of a bypass graft',
    },
    {
        value:
            'Coronary artery disease - Unstable angina requiring intravenous thrombolytic therapy (excluding anticoagulant and antiplatelet agents)',
        label:
            'Coronary artery disease - Unstable angina requiring intravenous thrombolytic therapy (excluding anticoagulant and antiplatelet agents)',
        Category:
            'Coronary artery disease - Unstable angina requiring intravenous thrombolytic therapy (excluding anticoagulant and antiplatelet agents)',
    },
    {
        value:
            'Ear, nose and throat disorders - Nasal bone destruction as a result of a disease process requiring reconstruction (trauma and cosmetic related problems are specifically excluded)',
        label:
            'Ear, nose and throat disorders - Nasal bone destruction as a result of a disease process requiring reconstruction (trauma and cosmetic related problems are specifically excluded)',
        Category: 'Ear, nose and throat disorders - Nasal bone destruction',
    },
    {
        value: 'Ear, nose and throat disorders - On diagnosis of mastoiditis',
        label: 'Ear, nose and throat disorders - On diagnosis of mastoiditis',
        Category: 'Ear, nose and throat disorders - Mastoiditis',
    },
    {
        value: 'Ear, nose and throat disorders - Otosclerosis resulting in hearing loss',
        label: 'Ear, nose and throat disorders - Otosclerosis resulting in hearing loss',
        Category: 'Ear, nose and throat disorders - Otosclerosis',
    },
    {
        value:
            'Ear, nose and throat disorders - Pure tone average hearing loss in both ears of 90 decibels or more',
        label:
            'Ear, nose and throat disorders - Pure tone average hearing loss in both ears of 90 decibels or more',
        Category: 'Ear, nose and throat disorders - Hearing loss',
    },
    {
        value:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 61 -69 decibels',
        label:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 61 -69 decibels',
        Category: 'Ear, nose and throat disorders - Hearing loss',
    },
    {
        value:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 70 - 89 decibels',
        label:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 70 - 89 decibels',
        Category: 'Ear, nose and throat disorders - Hearing loss',
    },
    {
        value:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 70 decibels or more',
        label:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 70 decibels or more',
        Category: 'Ear, nose and throat disorders - Hearing loss',
    },
    {
        value:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 90 decibels or more',
        label:
            'Ear, nose and throat disorders - Pure tone average hearing loss in one ear of 90 decibels or more',
        Category: 'Ear, nose and throat disorders - Hearing loss',
    },
    {
        value: 'Ear, nose and throat disorders - Recipient of cochlear or middle ear implant',
        label: 'Ear, nose and throat disorders - Recipient of cochlear or middle ear implant',
        Category: 'Ear, nose and throat disorders - Cochlear or middle ear implant',
    },
    {
        value: 'Ear, nose and throat disorders - Tympanosclerosis resulting in hearing loss',
        label: 'Ear, nose and throat disorders - Tympanosclerosis resulting in hearing loss',
        Category: 'Ear, nose and throat disorders - Tympanosclerosis',
    },
    {
        value:
            'Endocrine conditions - Endocrine tumours having undergone surgical excision including: adrenal adenoma (or adrenalectomy) phaeochromocytoma carcinoid tumour and thyroid adenoma pituitary tumour having undergone excision.',
        label:
            'Endocrine conditions - Endocrine tumours having undergone surgical excision including: adrenal adenoma (or adrenalectomy) phaeochromocytoma carcinoid tumour and thyroid adenoma pituitary tumour having undergone excision.',
        Category: 'Endocrine conditions - Endocrine tumours having undergone surgical excision',
    },
    {
        value:
            'Endocrine conditions - Having undergone daily injectable insulin treatment for a continuous 6 month period for Type II diabetes mellitus that was deemed medically necessary. This must be confirmed with appropriate evidence such as blood tests.',
        label:
            'Endocrine conditions - Having undergone daily injectable insulin treatment for a continuous 6 month period for Type II diabetes mellitus that was deemed medically necessary. This must be confirmed with appropriate evidence such as blood tests.',
        Category: 'Endocrine conditions - Insulin treatment for Type II diabetes mellitus',
    },
    {
        value:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: acromegaly',
        label:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: acromegaly',
        Category: 'Endocrine conditions - Acromegaly',
    },
    {
        value:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: addisonian crisis',
        label:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: addisonian crisis',
        Category: 'Endocrine conditions - Addisonian crisis',
    },
    {
        value:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Conn's syndrome.",
        label:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Conn's syndrome.",
        Category: "Endocrine conditions - Conn's syndrome",
    },
    {
        value:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Cushing's syndrome.",
        label:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Cushing's syndrome.",
        Category: "Endocrine conditions - Cushing's syndrome",
    },
    {
        value:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: parathyroid tetany',
        label:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: parathyroid tetany',
        Category: 'Endocrine conditions - Parathyroid tetany',
    },
    {
        value:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: sheehan's syndrome.",
        label:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: sheehan's syndrome.",
        Category: "Endocrine conditions - Sheehan's syndrome",
    },
    {
        value:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Simmond's disease.",
        label:
            "Endocrine conditions - On diagnosis of the following endocrine disorder: Simmond's disease.",
        Category: "Endocrine conditions - Simmond's disease",
    },
    {
        value:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: thyrotoxic crisis',
        label:
            'Endocrine conditions - On diagnosis of the following endocrine disorder: thyrotoxic crisis',
        Category: 'Endocrine conditions - Thyrotoxic crisis',
    },
    {
        value: 'Endocrine conditions - On diagnosis of Type I diabetes',
        label: 'Endocrine conditions - On diagnosis of Type I diabetes',
        Category: 'Endocrine conditions - Type I diabetes',
    },
    {
        value: 'Endometrial cancer: Stage I',
        label: 'Endometrial cancer: Stage I',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage I',
        label: 'Endometrial cancer: Stage I',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage II',
        label: 'Endometrial cancer: Stage II',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage II',
        label: 'Endometrial cancer: Stage II',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage III',
        label: 'Endometrial cancer: Stage III',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage III',
        label: 'Endometrial cancer: Stage III',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage IV',
        label: 'Endometrial cancer: Stage IV',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage IV',
        label: 'Endometrial cancer: Stage IV',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Eye cancer: Stage I',
        label: 'Eye cancer: Stage I',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage I',
        label: 'Eye cancer: Stage I',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage II',
        label: 'Eye cancer: Stage II',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage II',
        label: 'Eye cancer: Stage II',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage III',
        label: 'Eye cancer: Stage III',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage III',
        label: 'Eye cancer: Stage III',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage IV',
        label: 'Eye cancer: Stage IV',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage IV',
        label: 'Eye cancer: Stage IV',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye disorders - Chronic corneal ulcer of 3 months or longer duration',
        label: 'Eye disorders - Chronic corneal ulcer of 3 months or longer duration',
        Category: 'Eye disorders - Chronic corneal ulcer',
    },
    {
        value: 'Eye disorders - Corneal transplant',
        label: 'Eye disorders - Corneal transplant',
        Category: 'Eye disorders - Corneal transplant',
    },
    {
        value: 'Eye disorders - Irreversible diabetic retinopathy (Grade III)',
        label: 'Eye disorders - Irreversible diabetic retinopathy (Grade III)',
        Category: 'Eye disorders - Irreversible diabetic retinopathy (Grade III)',
    },
    {
        value: 'Eye disorders - Irreversible diabetic retinopathy (Grade IV)',
        label: 'Eye disorders - Irreversible diabetic retinopathy (Grade IV)',
        Category: 'Eye disorders - Irreversible diabetic retinopathy (Grade IV)',
    },
    {
        value: 'Eye disorders - Irreversible hemianopia in both eyes',
        label: 'Eye disorders - Irreversible hemianopia in both eyes',
        Category: 'Eye disorders - Irreversible hemianopia in both eyes',
    },
    {
        value: 'Eye disorders - Irreversible hemianopia in one eye',
        label: 'Eye disorders - Irreversible hemianopia in one eye',
        Category: 'Eye disorders - Irreversible hemianopia in one eye',
    },
    {
        value:
            'Eye disorders - Irreversible loss of sight in both eyes with best corrected bilateral visual acuity of 6/24 or worse',
        label:
            'Eye disorders - Irreversible loss of sight in both eyes with best corrected bilateral visual acuity of 6/24 or worse',
        Category: 'Eye disorders - Irreversible loss of sight in both eyes',
    },
    {
        value:
            'Eye disorders - Irreversible loss of sight in one eye where the visual activity is 6/30 or worse in the affected eye',
        label:
            'Eye disorders - Irreversible loss of sight in one eye where the visual activity is 6/30 or worse in the affected eye',
        Category: 'Eye disorders - Irreversible loss of sight in one eye',
    },
    {
        value: 'Eye disorders - Optic neuritis',
        label: 'Eye disorders - Optic neuritis',
        Category: 'Eye disorders - Optic neuritis',
    },
    {
        value:
            'Eye disorders - Orbital abscess treated with intravenous antibiotics or surgical drainage',
        label:
            'Eye disorders - Orbital abscess treated with intravenous antibiotics or surgical drainage',
        Category: 'Eye disorders - Orbital abscess',
    },
    {
        value: 'Eye disorders - Retinal detachment',
        label: 'Eye disorders - Retinal detachment',
        Category: 'Eye disorders - Retinal detachment',
    },
    {
        value: "Gastrointestinal disease - Crohn's disease On diagnosis of Parkinsons disease",
        label: "Gastrointestinal disease - Crohn's disease On diagnosis of Parkinsons disease",
        Category: "Gastrointestinal disease - Crohn's disease On diagnosis of Parkinsons disease",
    },
    {
        value: "Gastrointestinal disease - Crohn's disease or Ulcerative Colitis",
        label: "Gastrointestinal disease - Crohn's disease or Ulcerative Colitis",
        Category: "Gastrointestinal disease - Crohn's disease or Ulcerative Colitis`",
    },
    {
        value: 'Gastrointestinal disease - Having a permanent colostomy or ileostomy in place',
        label: 'Gastrointestinal disease - Having a permanent colostomy or ileostomy in place',
        Category: 'Gastrointestinal disease - Other Gastrointestinal condition',
    },
    {
        value:
            'Gastrointestinal disease - Having undergone recurrent surgery (at least a second surgery to colon or small intestine)',
        label:
            'Gastrointestinal disease - Having undergone recurrent surgery (at least a second surgery to colon or small intestine)',
        Category: 'Gastrointestinal disease - Other Gastrointestinal condition',
    },
    {
        value:
            'Gastrointestinal disease - Having undergone treatment for 4 continuous months with immunomodulators to control systems or having developed corticosteroid dependency.',
        label:
            'Gastrointestinal disease - Having undergone treatment for 4 continuous months with immunomodulators to control systems or having developed corticosteroid dependency.',
        Category: 'Gastrointestinal disease - Other Gastrointestinal condition',
    },
    {
        value:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        label:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        Category:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
    },
    {
        value:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        label:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        Category:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
    },
    {
        value: 'Gastrointestinal disease - Rectal fistula having undergone surgery',
        label: 'Gastrointestinal disease - Rectal fistula having undergone surgery',
        Category: 'Gastrointestinal disease - Rectal fistula having undergone surgery',
    },
    {
        value:
            'Gastrointestinal disease - Total colectomy (removal or the ascending descending and transverse colon)',
        label:
            'Gastrointestinal disease - Total colectomy (removal or the ascending descending and transverse colon)',
        Category: 'Gastrointestinal disease - Total colectomy',
    },
    {
        value: 'Gastrointestinal disease - Trachael oesophageal fistula having undergone surgery',
        label: 'Gastrointestinal disease - Trachael oesophageal fistula having undergone surgery',
        Category:
            'Gastrointestinal disease - Trachael oesophageal fistula having undergone surgery',
    },
    {
        value:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        label:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        Category:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
    },
    {
        value:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        label:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        Category:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
    },
    {
        value: 'Heart Transplant - A heart transplant',
        label: 'Heart Transplant - A heart transplant',
        Category: 'Heart Transplant - Heart Transplant',
    },
    {
        value: 'Liver cancer: Stage I',
        label: 'Liver cancer: Stage I',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage I',
        label: 'Liver cancer: Stage I',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage II',
        label: 'Liver cancer: Stage II',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage II',
        label: 'Liver cancer: Stage II',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage III',
        label: 'Liver cancer: Stage III',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage III',
        label: 'Liver cancer: Stage III',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage IV',
        label: 'Liver cancer: Stage IV',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage IV',
        label: 'Liver cancer: Stage IV',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value:
            'Living Lifestyle Catch All - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Living Lifestyle Catch All - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Living Lifestyle Catch All - Permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Living Lifestyle Catch All - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Living Lifestyle Catch All - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Living Lifestyle Catch All - Permanent inability to independently perform Activities of Daily Living',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 foot',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 foot',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 foot',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand and one foot',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand and one foot',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 hand and 1 foot',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 limb',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 limb',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 1 limb',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 feet',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 feet',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 feet',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 hands',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 hands',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of 2 hands',
    },
    {
        value:
            'Loss of and loss of use of limbs - Loss of use of or loss of 3 or more fingers on the same hand',
        label:
            'Loss of and loss of use of limbs - Loss of use of or loss of 3 or more fingers on the same hand',
        Category:
            'Loss of and loss of use of limbs - Loss of use of or loss of 3 or more fingers on the same hand',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of a thumb',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of a thumb',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of a thumb',
    },
    {
        value: 'Loss of and loss of use of limbs - Loss of use of or loss of more than one limb',
        label: 'Loss of and loss of use of limbs - Loss of use of or loss of more than one limb',
        Category: 'Loss of and loss of use of limbs - Loss of use of or loss of more than one limb',
    },
    {
        value: 'Loss of and loss of use of limbs - Major joint replacement',
        label: 'Loss of and loss of use of limbs - Major joint replacement',
        Category: 'Loss of and loss of use of limbs - Major joint replacement',
    },
    {
        value:
            'Loss of and loss of use of limbs - Surgical repair of major motor nerve after complete severance',
        label:
            'Loss of and loss of use of limbs - Surgical repair of major motor nerve after complete severance',
        Category:
            'Loss of and loss of use of limbs - Surgical repair of major motor nerve after complete severance',
    },
    {
        value:
            'Loss of sight - Irreversible loss of sight in both eyes with best corrected bilateral visual acuity of 6/30 or worse',
        label:
            'Loss of sight - Irreversible loss of sight in both eyes with best corrected bilateral visual acuity of 6/30 or worse',
        Category: 'Loss of sight - Irreversible loss of sight in both eyes',
    },
    {
        value: 'Lung cancer: Stage I',
        label: 'Lung cancer: Stage I',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage I',
        label: 'Lung cancer: Stage I',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage II',
        label: 'Lung cancer: Stage II',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage II',
        label: 'Lung cancer: Stage II',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage III',
        label: 'Lung cancer: Stage III',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage III',
        label: 'Lung cancer: Stage III',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage IV',
        label: 'Lung cancer: Stage IV',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage IV',
        label: 'Lung cancer: Stage IV',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Cancer and Leukaemia - Acute Lymphoblastic Leaukaemia',
        label: 'Cancer and Leukaemia - Acute Lymphoblastic Leaukaemia',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage 0 on the Rai classification system',
        label:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage 0 on the Rai classification system',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage I on the Rai classification system',
        label:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage I on the Rai classification system',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage II on the Rai classification system',
        label:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage II on the Rai classification system',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage III on the Rai classification system',
        label:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage III on the Rai classification system',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage IV on the Rai classification system',
        label:
            'Cancer and Leukaemia - Chronic Lumphocytic Leukaemia: Stage IV on the Rai classification system',
        Category: 'Cancer and leukaemia - Lymph cancer',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Major burns - Full thickness burns',
        label: 'Major burns - Full thickness burns',
        Category: 'Major burns - Full thickness burns',
    },
    {
        value:
            'Major burns - Involving more than 10% but less than or equal to 20% of the body surface area',
        label:
            'Major burns - Involving more than 10% but less than or equal to 20% of the body surface area',
        Category: 'Major burns - Other: Major Burns (%)',
    },
    {
        value: 'Major burns - Involving more than 15% of the body',
        label: 'Major burns - Involving more than 15% of the body',
        Category: 'Major burns - Other: Major Burns (%)',
    },
    {
        value:
            'Major burns - Involving more than 20% but less than or equal to 30% of the body surface area',
        label:
            'Major burns - Involving more than 20% but less than or equal to 30% of the body surface area',
        Category: 'Major burns - Other: Major Burns (%)',
    },
    {
        value: 'Major burns - Involving more than 30% of the body surface area',
        label: 'Major burns - Involving more than 30% of the body surface area',
        Category: 'Major burns - Other: Major Burns (%)',
    },
    {
        value: 'Major burns - Involving one hand: Major burns Involving one hand',
        label: 'Major burns - Involving one hand: Major burns Involving one hand',
        Category: 'Major burns - One hand',
    },
    {
        value: 'Major burns - Involving the face the airways or both hands',
        label: 'Major burns - Involving the face the airways or both hands',
        Category: 'Major burns - The face, the airways or both hands',
    },
    {
        value: 'Major burns - Partial thickness burns',
        label: 'Major burns - Partial thickness burns',
        Category: 'Major burns - Partial thickness burns',
    },
    {
        value:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        label:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        label:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage I',
        label: 'Malignant melanoma: Stage I',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage I',
        label: 'Malignant melanoma: Stage I',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage II',
        label: 'Malignant melanoma: Stage II',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage II',
        label: 'Malignant melanoma: Stage II',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage III',
        label: 'Malignant melanoma: Stage III',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage III',
        label: 'Malignant melanoma: Stage III',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage IV',
        label: 'Malignant melanoma: Stage IV',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage IV',
        label: 'Malignant melanoma: Stage IV',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Cancer and leukaemia - Acute Myeloblastic Leukaemia',
        label: 'Cancer and leukaemia - Acute Myeloblastic Leukaemia',
        Category: 'Cancer and leukaemia - Metastatic cancer',
    },
    {
        value: 'Cancer and leukaemia - Chronic Myeloid Leukaemia(no bone marrow transplantation)',
        label: 'Cancer and leukaemia - Chronic Myeloid Leukaemia(no bone marrow transplantation)',
        Category: 'Cancer and leukaemia - Metastatic cancer',
    },
    {
        value:
            'Cancer and leukaemia - Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        label:
            'Cancer and leukaemia - Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        Category: 'Cancer and leukaemia - Metastatic cancer',
    },
    {
        value:
            'Motor neuron disease - On diagnosis of motor neurone disease by an appropriate specialist',
        label:
            'Motor neuron disease - On diagnosis of motor neurone disease by an appropriate specialist',
        Category:
            'Motor neuron disease - On diagnosis of motor neurone disease by an appropriate specialist',
    },
    {
        value: 'Multiple myeloma: Stage I (R-ISS)',
        label: 'Multiple myeloma: Stage I (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage I (R-ISS)',
        label: 'Multiple myeloma: Stage I (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage II (R-ISS)',
        label: 'Multiple myeloma: Stage II (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage II (R-ISS)',
        label: 'Multiple myeloma: Stage II (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage III (R-ISS)',
        label: 'Multiple myeloma: Stage III (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage III (R-ISS)',
        label: 'Multiple myeloma: Stage III (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple sclerosis - On diagnosis of multiple sclerosis',
        label: 'Multiple sclerosis - On diagnosis of multiple sclerosis',
        Category: 'Multiple sclerosis - On diagnosis of multiple sclerosis',
    },
    {
        value: 'Multiple sclerosis - On diagnosis of progressive multiple sclerosis',
        label: 'Multiple sclerosis - On diagnosis of progressive multiple sclerosis',
        Category: 'Multiple sclerosis - On diagnosis of progressive multiple sclerosis',
    },
    {
        value:
            'Multiple sclerosis - Optic neuritis where 2 or more plaques are seen to be demyelinating on an MRI',
        label:
            'Multiple sclerosis - Optic neuritis where 2 or more plaques are seen to be demyelinating on an MRI',
        Category:
            'Multiple sclerosis - Optic neuritis where 2 or more plaques are seen to be demyelinating on an MRI',
    },
    {
        value:
            'Multiple sclerosis - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Multiple sclerosis - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Multiple sclerosis - Relapsingremitting multiple sclerosis resulting in the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Multiple sclerosis - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Multiple sclerosis - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Multiple sclerosis - Relapsingremitting multiple sclerosis resulting in the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Multiple sclerosis - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Multiple sclerosis - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Multiple sclerosis - Relapsingremitting multiple sclerosis resulting in the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value: 'Muscular dystrophy - On diagnosis of muscular dystrophy',
        label: 'Muscular dystrophy - On diagnosis of muscular dystrophy',
        Category: 'Muscular dystrophy - On diagnosis of muscular dystrophy',
    },
    {
        value:
            'Muscular dystrophy - Scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Muscular dystrophy - Scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Muscular dystrophy - Muscular dystrophy resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Muscular dystrophy - Scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Muscular dystrophy - Scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Muscular dystrophy - Muscular dystrophy resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Musculoskeletal - Musculoskeletal involvement of the major joints with evidence of ongoing therapy',
        label:
            'Musculoskeletal - Musculoskeletal involvement of the major joints with evidence of ongoing therapy',
        Category: 'Musculoskeletal - Involvement of major joints with evidence of ongoing therapy',
    },
    {
        value: 'Myasthenia gravis - On diagnosis of myasthenia gravis',
        label: 'Myasthenia gravis - On diagnosis of myasthenia gravis',
        Category: 'Myasthenia gravis - On diagnosis of myasthenia gravis',
    },
    {
        value:
            'Myasthenia gravis - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Myasthenia gravis - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Myasthenia gravis - Myasthenia gravis resulting in the permanent inability to independently perform activities of daily living',
    },
    {
        value:
            'Myasthenia gravis - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Myasthenia gravis - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Myasthenia gravis - Myasthenia gravis resulting in the permanent inability to independently perform activities of daily living',
    },
    {
        value:
            'Myasthenia gravis - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Myasthenia gravis - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Myasthenia gravis - Myasthenia gravis resulting in the permanent inability to independently perform activities of daily living',
    },
    {
        value: 'Myocardial infarction (heart attack) - A heart transplant',
        label: 'Myocardial infarction (heart attack) - A heart transplant',
        Category: 'Myocardial infarction (heart attack) - Heart transplant',
    },
    {
        value:
            'Myocardial infarction (heart attack) - Acute heart failure as diagnosed by an appropriate specialist and EF < 45 % at time of diagnosis',
        label:
            'Myocardial infarction (heart attack) - Acute heart failure as diagnosed by an appropriate specialist and EF < 45 % at time of diagnosis',
        Category:
            'Myocardial infarction (heart attack) - Acute heart failure as diagnosed by an appropriate specialist and EF < 45 % at time of diagnosis',
    },
    {
        value:
            'Myocardial infarction (heart attack) - But still NYHA class 3 (or METS < 5) and EF < 50% as measured 6 weeks after the myocardial infarction',
        label:
            'Myocardial infarction (heart attack) - But still NYHA class 3 (or METS < 5) and EF < 50% as measured 6 weeks after the myocardial infarction',
        Category:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 Myocardial Infarction; and receiving optimal treatment (whether that is medical or surgical)',
    },
    {
        value:
            'Myocardial infarction (heart attack) - But still NYHA class 4 (or METS < 3) and EF < 40% as measured 6 weeks after the myocardial infarction',
        label:
            'Myocardial infarction (heart attack) - But still NYHA class 4 (or METS < 3) and EF < 40% as measured 6 weeks after the myocardial infarction',
        Category:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 Myocardial Infarction; and receiving optimal treatment (whether that is medical or surgical)',
    },
    {
        value:
            'Myocardial infarction (heart attack) - But still NYHA class 4 (or METS < 5) and EF < 50% as measured 6 weeks after the myocardial infarction',
        label:
            'Myocardial infarction (heart attack) - But still NYHA class 4 (or METS < 5) and EF < 50% as measured 6 weeks after the myocardial infarction',
        Category:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 Myocardial Infarction; and receiving optimal treatment (whether that is medical or surgical)',
    },
    {
        value:
            'Myocardial infarction (heart attack) - Myocardial infarction as defined in the policy document but Trop T > 10 ng/ml or Trop I > 05 ng/ml',
        label:
            'Myocardial infarction (heart attack) - Myocardial infarction as defined in the policy document but Trop T > 10 ng/ml or Trop I > 05 ng/ml',
        Category:
            'Myocardial infarction (heart attack) - Myocardial infarction as defined in the policy document but Trop T > 10 ng/ml or Trop I > 05 ng/ml',
    },
    {
        value:
            'Myocardial infarction (heart attack) - Myocardial infarction resulting in at least 2 of the following: 1. New pathological Q-waves on ECG or 2. Compatible clinical symptoms or 3. Raised cardiac markers: • Trop T > 10 ng/ml or Trop I > 05 ng/ml or more than 4 times normal values postintervention or • Total CPK elevation of more than 2x normal values with at least 6% being CKMB',
        label:
            'Myocardial infarction (heart attack) - Myocardial infarction resulting in at least 2 of the following: 1. New pathological Q-waves on ECG or 2. Compatible clinical symptoms or 3. Raised cardiac markers: • Trop T > 10 ng/ml or Trop I > 05 ng/ml or more than 4 times normal values postintervention or • Total CPK elevation of more than 2x normal values with at least 6% being CKMB',
        Category:
            'Myocardial infarction (heart attack) - Myocardial infarction resulting in at least 2 of the following:',
    },
    {
        value:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 myocardial Infarction',
        label:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 myocardial Infarction',
        Category:
            'Myocardial infarction (heart attack) - On diagnosis of a myocardial infarction as specified at the beginning of benefit category 2.3 Myocardial Infarction',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Oesophageal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Cervical',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Colorectal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Liver',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Lung',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Ovarian',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Pancreatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Renal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Stomach',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Thyroid',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Breast',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Prostate',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Bladder',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Endometrial',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Eye',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Metastatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Skin',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Testicular',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Tongue',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Uterus',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Other',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Oesophageal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Cervical',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Colorectal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Liver',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Lung',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Ovarian',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Pancreatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Renal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Stomach',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Thyroid',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Breast',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Prostate',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Bladder',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Endometrial',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Eye',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Metastatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Skin',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Testicular',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Tongue',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Uterus',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Other',
    },
    {
        value: 'Not Applicable',
        label: 'Not Applicable',
        Category: 'Not Applicable',
    },
    {
        value: 'Not Applicable',
        label: 'Not Applicable',
        Category:
            'Cerebrovascular incident (Stoke) - Stroke resulting in permanent neurological impairment',
    },
    {
        value: 'Not Applicable',
        label: 'Not Applicable',
        Category: 'Not Applicable',
    },
    {
        value: 'Oesophageal cancer: Stage I',
        label: 'Oesophageal cancer: Stage I',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage I',
        label: 'Oesophageal cancer: Stage I',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage II',
        label: 'Oesophageal cancer: Stage II',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage II',
        label: 'Oesophageal cancer: Stage II',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage III',
        label: 'Oesophageal cancer: Stage III',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage III',
        label: 'Oesophageal cancer: Stage III',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage IV',
        label: 'Oesophageal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage IV',
        label: 'Oesophageal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value:
            'Other autoimmune disorders - Arteritis or endarteritis diagnosed on biopsy and having been hospitalised for more than 7 days',
        label:
            'Other autoimmune disorders - Arteritis or endarteritis diagnosed on biopsy and having been hospitalised for more than 7 days',
        Category: 'Other autoimmune disorders - Arteritis or endarteritis',
    },
    {
        value:
            'Other autoimmune disorders - Complications involving the musculoskeletal system having undergone surgery including joint replacement joint reconstruction and joint fixation',
        label:
            'Other autoimmune disorders - Complications involving the musculoskeletal system having undergone surgery including joint replacement joint reconstruction and joint fixation',
        Category: 'Other autoimmune disorders - Complications involving the musculoskeletal system',
    },
    {
        value:
            'Other autoimmune disorders - Disorders resulting in the failure of one or more major organs despite optimal treatment as defined in the relevant benefit categories excluding the skin',
        label:
            'Other autoimmune disorders - Disorders resulting in the failure of one or more major organs despite optimal treatment as defined in the relevant benefit categories excluding the skin',
        Category:
            'Other autoimmune disorders - Disorders resulting in the failure of one or more major organs despite optimal treatment as defined in the relevant benefit categories excluding the skin',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders involving one major organ excluding the skin',
        label:
            'Other autoimmune disorders - Other autoimmune disorders involving one major organ excluding the skin',
        Category: 'Other autoimmune disorders - Disorders involving one major organ',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders producing symptoms and involving three or more of the following major organs: lung heart brain liver and kidneys',
        label:
            'Other autoimmune disorders - Other autoimmune disorders producing symptoms and involving three or more of the following major organs: lung heart brain liver and kidneys',
        Category:
            'Other autoimmune disorders - Disorders producing systoms and involving three or more major organs',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders producing symptoms and involving two or more of the following major organs: lung heart brain liver and kidneys',
        label:
            'Other autoimmune disorders - Other autoimmune disorders producing symptoms and involving two or more of the following major organs: lung heart brain liver and kidneys',
        Category:
            'Other autoimmune disorders - Disorders producing systoms and involving two or more major organs',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders resulting in permanent inability to independently perform Activities of Daily Living scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Other autoimmune disorders - Other autoimmune disorders resulting in permanent inability to independently perform Activities of Daily Living scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Other autoimmune disorders - Disorders resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders resulting in permanent inability to independently perform Activities of Daily Living scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Other autoimmune disorders - Other autoimmune disorders resulting in permanent inability to independently perform Activities of Daily Living scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Other autoimmune disorders - Disorders resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other autoimmune disorders - Other autoimmune disorders resulting in the failure of one or more major organs despite optimal treatment as defined in the relevant benefit categories excluding the skin',
        label:
            'Other autoimmune disorders - Other autoimmune disorders resulting in the failure of one or more major organs despite optimal treatment as defined in the relevant benefit categories excluding the skin',
        Category:
            'Other autoimmune disorders - Disorders producing systoms and involving one or more major organs',
    },
    {
        value: 'Cancer and leukaemia - Hairy cell leukaemia',
        label: 'Cancer and leukaemia - Hairy cell leukaemia',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Cancer and leukaemia - Metastastic cancer',
        label: 'Cancer and leukaemia - Metastastic cancer',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage I',
        label: 'Other cancer: Stage I',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage I',
        label: 'Other cancer: Stage I',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage II',
        label: 'Other cancer: Stage II',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage II',
        label: 'Other cancer: Stage II',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage III',
        label: 'Other cancer: Stage III',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage III',
        label: 'Other cancer: Stage III',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage IV',
        label: 'Other cancer: Stage IV',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage IV',
        label: 'Other cancer: Stage IV',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value:
            'Other central nervous system disorders - Any condition or brain abscess having undergone open brain surgery',
        label:
            'Other central nervous system disorders - Any condition or brain abscess having undergone open brain surgery',
        Category:
            'Other central nervous system disorders - Any condition or brain abscess having undergone open brain surgery',
    },
    {
        value:
            'Other central nervous system disorders - Benign brain tumour treated using radiosurgery or stereostactic surgery',
        label:
            'Other central nervous system disorders - Benign brain tumour treated using radiosurgery or stereostactic surgery',
        Category: 'Other central nervous system disorders - Benign brain tumour',
    },
    {
        value:
            'Other central nervous system disorders - Brain abscess having undergone surgical drainage',
        label:
            'Other central nervous system disorders - Brain abscess having undergone surgical drainage',
        Category:
            'Other central nervous system disorders - Brain abscess having undergone surgical drainage',
    },
    {
        value: 'Other central nervous system disorders - Cerebral malaria',
        label: 'Other central nervous system disorders - Cerebral malaria',
        Category: 'Other central nervous system disorders - Cerebral malaria',
    },
    {
        value:
            'Other central nervous system disorders - Cerebral oedema having undergone in-hospital treatment with specific therapeutic interventions',
        label:
            'Other central nervous system disorders - Cerebral oedema having undergone in-hospital treatment with specific therapeutic interventions',
        Category:
            'Other central nervous system disorders - Cerebral malaria resulting in permanent neurological impairment assessed according to the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other central nervous system disorders - Conditions having undergone open brain surgery excluding arteriovenous malformation or intracranial aneurysm',
        label:
            'Other central nervous system disorders - Conditions having undergone open brain surgery excluding arteriovenous malformation or intracranial aneurysm',
        Category:
            'Other central nervous system disorders - Cerebral oedema having undergone in-hospital treatment with specific therapeutic interventions',
    },
    {
        value:
            'Other central nervous system disorders - Intracranial aneurysm or an arteriovenous malformation having undergone endoscopic or stereotactic surgical intervention',
        label:
            'Other central nervous system disorders - Intracranial aneurysm or an arteriovenous malformation having undergone endoscopic or stereotactic surgical intervention',
        Category:
            'Other central nervous system disorders - Intracranial aneurysm or arteriovenous malformation',
    },
    {
        value:
            'Other central nervous system disorders - Intracranial aneurysm or an arteriovenous malformation having undergone open brain surgery',
        label:
            'Other central nervous system disorders - Intracranial aneurysm or an arteriovenous malformation having undergone open brain surgery',
        Category:
            'Other central nervous system disorders - Permanent and complete inability to communicate or comprehend language symbols',
    },
    {
        value:
            'Other central nervous system disorders - Permanent and complete inability to communicate or comprehend language symbols',
        label:
            'Other central nervous system disorders - Permanent and complete inability to communicate or comprehend language symbols',
        Category:
            'Other central nervous system disorders - Raised intracranial pressure causing symptoms',
    },
    {
        value:
            'Other central nervous system disorders - Raised intracranial pressure causing symptoms',
        label:
            'Other central nervous system disorders - Raised intracranial pressure causing symptoms',
        Category:
            'Other central nervous system disorders - Recurrent benign brain tumour showing symptoms',
    },
    {
        value:
            'Other central nervous system disorders - Recurrent benign brain tumour showing symptoms',
        label:
            'Other central nervous system disorders - Recurrent benign brain tumour showing symptoms',
        Category:
            'Other central nervous system disorders - Status epilepticus (unremitting convulsions) resulting in permanent neurological impairment assessed according to the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other central nervous system disorders - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Other central nervous system disorders - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Other central nervous system disorders - Benign brain tumour or brain abscess intracranial aneurysm or arteriovenous malformation resulting in permanent neurological impairment assessed according to the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other central nervous system disorders - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Other central nervous system disorders - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Other central nervous system disorders - Benign brain tumour or brain abscess intracranial aneurysm or arteriovenous malformation resulting in permanent neurological impairment assessed according to the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other central nervous system disorders - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Other central nervous system disorders - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Other central nervous system disorders - Benign brain tumour or brain abscess intracranial aneurysm or arteriovenous malformation resulting in permanent neurological impairment assessed according to the permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Other central nervous system disorders - The first occurrence of hydrocephalus having undergone a shunt',
        label:
            'Other central nervous system disorders - The first occurrence of hydrocephalus having undergone a shunt',
        Category: 'Other central nervous system disorders - Hydrocephalus',
    },
    {
        value:
            'Other central nervous system disorders - With mechanical ventilation for more than 60 consecutive days',
        label:
            'Other central nervous system disorders - With mechanical ventilation for more than 60 consecutive days',
        Category:
            'Other central nervous system disorders - Conditions having undergone open brain surgery excluding arteriovenous malformation or intracranial aneurysm',
    },
    {
        value:
            'Other central nervous system disorders - With neurological deficit for a continuous period of 6 months',
        label:
            'Other central nervous system disorders - With neurological deficit for a continuous period of 6 months',
        Category: 'Other central nervous system disorders - GuillainBarrÃ© syndrome',
    },
    {
        value: 'Ovarian cancer: Stage I',
        label: 'Ovarian cancer: Stage I',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage I',
        label: 'Ovarian cancer: Stage I',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage II',
        label: 'Ovarian cancer: Stage II',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage II',
        label: 'Ovarian cancer: Stage II',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage III',
        label: 'Ovarian cancer: Stage III',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage III',
        label: 'Ovarian cancer: Stage III',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage IV',
        label: 'Ovarian cancer: Stage IV',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage IV',
        label: 'Ovarian cancer: Stage IV',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Pancreatic cancer: Stage I',
        label: 'Pancreatic cancer: Stage I',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage I',
        label: 'Pancreatic cancer: Stage I',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage II',
        label: 'Pancreatic cancer: Stage II',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage II',
        label: 'Pancreatic cancer: Stage II',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage III',
        label: 'Pancreatic cancer: Stage III',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage III',
        label: 'Pancreatic cancer: Stage III',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage IV',
        label: 'Pancreatic cancer: Stage IV',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage IV',
        label: 'Pancreatic cancer: Stage IV',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic disorders - A pancreas transplant',
        label: 'Pancreatic disorders - A pancreas transplant',
        Category: 'Pancreatic disorders - A pancreas transplant',
    },
    {
        value:
            'Pancreatic disorders - Causing impaired glucose tolerance resulting in treatment with injectable insulin',
        label:
            'Pancreatic disorders - Causing impaired glucose tolerance resulting in treatment with injectable insulin',
        Category: 'Pancreatic disorders - Chronic pancreatitis',
    },
    {
        value: 'Pancreatic disorders - Causing malabsorption syndrome',
        label: 'Pancreatic disorders - Causing malabsorption syndrome',
        Category: 'Pancreatic disorders - Chronic pancreatitis',
    },
    {
        value: 'Pancreatic disorders - Complete pancreatectomy',
        label: 'Pancreatic disorders - Complete pancreatectomy',
        Category: 'Pancreatic disorders - Complete pancreatectomy',
    },
    {
        value: 'Pancreatic disorders - Pancreatic abscess having undergone surgical drainage',
        label: 'Pancreatic disorders - Pancreatic abscess having undergone surgical drainage',
        Category: 'Pancreatic disorders - Pancreatic abscess having undergone surgical drainage',
    },
    {
        value: 'Pancreatic disorders - Partial pancreatectomy due to disease',
        label: 'Pancreatic disorders - Partial pancreatectomy due to disease',
        Category: 'Pancreatic disorders - Partial pancreatectomy due to disease',
    },
    {
        value: 'Paralysis - Paralysis: Diplegia',
        label: 'Paralysis - Paralysis: Diplegia',
        Category: 'Paralysis - Diplegia',
    },
    {
        value: 'Paralysis - Paralysis: Hemiplegia',
        label: 'Paralysis - Paralysis: Hemiplegia',
        Category: 'Paralysis - Hemiplegia',
    },
    {
        value: 'Paralysis - Paralysis: Paraplegia',
        label: 'Paralysis - Paralysis: Paraplegia',
        Category: 'Paralysis - Paraplegia',
    },
    {
        value: 'Paralysis - Paralysis: Quadriplegia',
        label: 'Paralysis - Paralysis: Quadriplegia',
        Category: 'Paralysis - Quadriplegia',
    },
    {
        value: "Parkinson's disease - On diagnosis of Parkinsons disease",
        label: "Parkinson's disease - On diagnosis of Parkinsons disease",
        Category: "Parkinson's disease - On diagnosis of Parkinsons disease",
    },
    {
        value:
            "Parkinson's disease - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table.",
        label:
            "Parkinson's disease - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table.",
        Category:
            "Parkinson's disease - Parkinsons disease resulting in the permanent inability to independently perform Activities of Daily Living`",
    },
    {
        value:
            "Parkinson's disease - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table`",
        label:
            "Parkinson's disease - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table`",
        Category:
            "Parkinson's disease - Parkinsons disease resulting in the permanent inability to independently perform Activities of Daily Living`",
    },
    {
        value:
            "Parkinson's disease - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table",
        label:
            "Parkinson's disease - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table",
        Category:
            "Parkinson's disease - Parkinsons disease resulting in the permanent inability to independently perform Activities of Daily Living`",
    },
    {
        value:
            'Pericardial disease - Acute or chronic pericarditis as seen on special investigation',
        label:
            'Pericardial disease - Acute or chronic pericarditis as seen on special investigation',
        Category:
            'Pericardial disease - Acute or chronic pericarditis as seen on special investigation',
    },
    {
        value: 'Pericardial disease - But still NYHA class 3 (or METS < 5) and EF < 50%',
        label: 'Pericardial disease - But still NYHA class 3 (or METS < 5) and EF < 50%',
        Category:
            'Pericardial disease - Receiving optimal treatment (whether that is medical or surgical) for a pericardial disease',
    },
    {
        value: 'Pericardial disease - But still NYHA class 4 (or METS < 3) and EF < 40%',
        label: 'Pericardial disease - But still NYHA class 4 (or METS < 3) and EF < 40%',
        Category:
            'Pericardial disease - Receiving optimal treatment (whether that is medical or surgical) for a pericardial disease',
    },
    {
        value: 'Pericardial disease - But still NYHA class 4 (or METS < 5) and EF < 50%',
        label: 'Pericardial disease - But still NYHA class 4 (or METS < 5) and EF < 50%',
        Category:
            'Pericardial disease - Receiving optimal treatment (whether that is medical or surgical) for a pericardial disease',
    },
    {
        value: 'Pericardial disease - Keyhole pericardiectomy',
        label: 'Pericardial disease - Keyhole pericardiectomy',
        Category: 'Pericardial disease - Keyhole pericardiectomy',
    },
    {
        value: 'Pericardial disease - Openheart pericardiectomy',
        label: 'Pericardial disease - Openheart pericardiectomy',
        Category: 'Pericardial disease - Openheart pericardiectomy',
    },
    {
        value: 'Pericardial disease - Pericardiectomy done endoscopically',
        label: 'Pericardial disease - Pericardiectomy done endoscopically',
        Category: 'Pericardial disease - Pericardiectomy done endoscopically',
    },
    {
        value:
            'Peripheral arterial disease - Gangrene or loss of limb due to peripheral arterial disease',
        label:
            'Peripheral arterial disease - Gangrene or loss of limb due to peripheral arterial disease',
        Category:
            'Peripheral arterial disease - Gangrene or loss of limb due to peripheral arterial disease',
    },
    {
        value:
            'Peripheral arterial disease - Occlusion of major artery (50% or more) as evidenced by positive imaging and clinical findings',
        label:
            'Peripheral arterial disease - Occlusion of major artery (50% or more) as evidenced by positive imaging and clinical findings',
        Category:
            'Peripheral arterial disease - Occlusion of major artery (50% or more) as evidenced by positive imaging and clinical findings',
    },
    {
        value:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disease and angioplasty with 2 or more stents in a single vessel or in separate vessels',
        label:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disease and angioplasty with 2 or more stents in a single vessel or in separate vessels',
        Category:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disease; and angioplasty with 2 or more stents in a single vessel or in separate vessels',
    },
    {
        value:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disesse and angioplasty with or without stenting of a peripheral artery',
        label:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disesse and angioplasty with or without stenting of a peripheral artery',
        Category:
            'Peripheral arterial disease - On diagnosis of a peripheral arterial disease as specified at the beginning of benefit category 2.7 Peripheral arterial disesse; and angioplasty with or without stenting of a peripheral artery',
    },
    {
        value:
            'Peripheral arterial disease - Receiving optimal treatment (whether that is surgical or medical) for peripheral arterial disease but still experiencing persistent claudication and leg ulcer/s dystrophic changes or colour changes',
        label:
            'Peripheral arterial disease - Receiving optimal treatment (whether that is surgical or medical) for peripheral arterial disease but still experiencing persistent claudication and leg ulcer/s dystrophic changes or colour changes',
        Category:
            'Peripheral arterial disease - Receiving optimal treatment (whether that is surgical or medical) for peripheral arterial disease but still experiencing persistent claudication and leg ulcer/s dystrophic changes or colour changes',
    },
    {
        value:
            'Peripheral arterial disease - Surgery to correct the narrowing of or blockage to a peripheral artery / arteries by means of a bypass graft',
        label:
            'Peripheral arterial disease - Surgery to correct the narrowing of or blockage to a peripheral artery / arteries by means of a bypass graft',
        Category:
            'Peripheral arterial disease - Surgery to correct the narrowing of or blockage to a peripheral artery / arteries by means of a bypass graft',
    },
    {
        value: 'Prostate - T1NOMO',
        label: 'Prostate - T1NOMO',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO',
        label: 'Prostate - T1NOMO',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO Gleason >7',
        label: 'Prostate - T1NOMO Gleason >7',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO Gleason >7',
        label: 'Prostate - T1NOMO Gleason >7',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T2NOMO (any grade)',
        label: 'Prostate - T2NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T2NOMO (any grade)',
        label: 'Prostate - T2NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T3NOMO (any grade)',
        label: 'Prostate - T3NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T3NOMO (any grade)',
        label: 'Prostate - T3NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        label:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        label:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Renal cancer: Stage I',
        label: 'Renal cancer: Stage I',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage I',
        label: 'Renal cancer: Stage I',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage II',
        label: 'Renal cancer: Stage II',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage II',
        label: 'Renal cancer: Stage II',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage III',
        label: 'Renal cancer: Stage III',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage III',
        label: 'Renal cancer: Stage III',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage IV',
        label: 'Renal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage IV',
        label: 'Renal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal disorders - A kidney transplant',
        label: 'Renal disorders - A kidney transplant',
        Category: 'Renal disorders - Kidney transplant',
    },
    {
        value:
            'Renal disorders - Chronic irreversible kidney failure requiring and already having undergone regular dialysis treatment',
        label:
            'Renal disorders - Chronic irreversible kidney failure requiring and already having undergone regular dialysis treatment',
        Category:
            'Renal disorders - Chronic irreversible kidney failure requiring and already having undergone regular dialysis treatment',
    },
    {
        value: 'Renal disorders - Chronic nephrotic syndrome',
        label: 'Renal disorders - Chronic nephrotic syndrome',
        Category: 'Renal disorders - Chronic nephrotic syndrome',
    },
    {
        value: 'Renal disorders - Chronic tubulointerstitial disease',
        label: 'Renal disorders - Chronic tubulointerstitial disease',
        Category: 'Renal disorders - Chronic tubulointerstitial disease',
    },
    {
        value:
            'Renal disorders - Endoscopic or minimally invasive renal surgery (excluding biopsy or any surgery for renal stones)',
        label:
            'Renal disorders - Endoscopic or minimally invasive renal surgery (excluding biopsy or any surgery for renal stones)',
        Category:
            'Renal disorders - Endoscopic or minimally invasive renal surgery (excluding biopsy or any surgery for renal stones)',
    },
    {
        value: 'Renal disorders - Having received intravenous antibiotics for 48 hours',
        label: 'Renal disorders - Having received intravenous antibiotics for 48 hours',
        Category: 'Renal disorders - Progressive chronic kidney disease',
    },
    {
        value: 'Renal disorders - Having undergone percutaneous drainage',
        label: 'Renal disorders - Having undergone percutaneous drainage',
        Category: 'Renal disorders - Renal abscess',
    },
    {
        value: 'Renal disorders - Nephrotic syndrome with renal artery or renal vein thrombosis',
        label: 'Renal disorders - Nephrotic syndrome with renal artery or renal vein thrombosis',
        Category: 'Renal disorders - Nephrotic syndrome with renal artery or renal vein thrombosis',
    },
    {
        value: 'Renal disorders - Open kidney surgery not for diagnostic purposes',
        label: 'Renal disorders - Open kidney surgery not for diagnostic purposes',
        Category: 'Renal disorders - Open kidney surgery not for diagnostic purposes',
    },
    {
        value: 'Renal disorders - Partial or total nephrectomy',
        label: 'Renal disorders - Partial or total nephrectomy',
        Category: 'Renal disorders - Partial or total nephrectomy',
    },
    {
        value: 'Renal disorders - Primary amyloidosis of the kidney',
        label: 'Renal disorders - Primary amyloidosis of the kidney',
        Category: 'Renal disorders - Primary amyloidosis of the kidney',
    },
    {
        value: 'Renal disorders - Renal cortical necrosis',
        label: 'Renal disorders - Renal cortical necrosis',
        Category: 'Renal disorders - Renal cortical necrosis',
    },
    {
        value:
            'Renal disorders - With the last GFR of 15ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        label:
            'Renal disorders - With the last GFR of 15ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        Category: 'Renal disorders - Progressive chronic kidney disease',
    },
    {
        value:
            'Renal disorders - With the last GFR of 30ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        label:
            'Renal disorders - With the last GFR of 30ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        Category: 'Renal disorders - Progressive chronic kidney disease',
    },
    {
        value:
            'Renal disorders - With the last GFR of 55ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        label:
            'Renal disorders - With the last GFR of 55ml/min or less (using the most accurate GFR test) with persistent proteinuria (1+ or more on Dipstick) and a documented decline in the GFR of greater than 5ml/min within the last 12 months despite optimal treatment by a nephrologist or a specialist physician.',
        Category: 'Renal disorders - Progressive chronic kidney disease',
    },
    {
        value: 'Respiratory disorders - A heartlung transplant',
        label: 'Respiratory disorders - A heartlung transplant',
        Category: 'Respiratory disorders - Heartlung transplant',
    },
    {
        value: 'Respiratory disorders - A lung transplant',
        label: 'Respiratory disorders - A lung transplant',
        Category: 'Respiratory disorders - Lung transplant',
    },
    {
        value: 'Respiratory disorders - Bronchopleural fistula having undergone surgery',
        label: 'Respiratory disorders - Bronchopleural fistula having undergone surgery',
        Category: 'Respiratory disorders - Bronchopleural fistula having undergone surgery',
    },
    {
        value:
            'Respiratory disorders - Chronic irreversible lung diseases including fibrosing alveolitis pneumoconiosis bronchiectasis interstitial lung diseases or chronic obstructive lung diseases resulting in FEV1 of less than 40% in obstructive diseases FVC of less than 40% in restrictive diseases',
        label:
            'Respiratory disorders - Chronic irreversible lung diseases including fibrosing alveolitis pneumoconiosis bronchiectasis interstitial lung diseases or chronic obstructive lung diseases resulting in FEV1 of less than 40% in obstructive diseases FVC of less than 40% in restrictive diseases',
        Category: 'Respiratory disorders - Chronic irreversible lung diseases',
    },
    {
        value:
            'Respiratory disorders - Chronic irreversible lung diseases including fibrosing alveolitis pneumoconiosis bronchiectasis interstitial lung diseases or chronic obstructive lung diseases resulting in FEV1 of less than 50% in obstructive diseases FVC of less than 50% in restrictive diseases',
        label:
            'Respiratory disorders - Chronic irreversible lung diseases including fibrosing alveolitis pneumoconiosis bronchiectasis interstitial lung diseases or chronic obstructive lung diseases resulting in FEV1 of less than 50% in obstructive diseases FVC of less than 50% in restrictive diseases',
        Category: 'Respiratory disorders - Chronic irreversible lung diseases',
    },
    {
        value:
            'Respiratory disorders - Having undergone the following surgical procedure: decortication',
        label:
            'Respiratory disorders - Having undergone the following surgical procedure: decortication',
        Category: 'Respiratory disorders - Decortication',
    },
    {
        value:
            'Respiratory disorders - Having undergone the following surgical procedure: drainage of empyema or lung abscess or pleural effusion requiring drainage',
        label:
            'Respiratory disorders - Having undergone the following surgical procedure: drainage of empyema or lung abscess or pleural effusion requiring drainage',
        Category:
            'Respiratory disorders - Drainage of empyema or lung abscess or pleural effusion requiring drainage',
    },
    {
        value:
            'Respiratory disorders - Having undergone the following surgical procedure: pleurectomy',
        label:
            'Respiratory disorders - Having undergone the following surgical procedure: pleurectomy',
        Category: 'Respiratory disorders - Pleurectomy',
    },
    {
        value: 'Respiratory disorders - Insertion of veno-caval filter',
        label: 'Respiratory disorders - Insertion of veno-caval filter',
        Category: 'Respiratory disorders - Insertion of venocaval filter',
    },
    {
        value: 'Respiratory disorders - On confirmed diagnosis of bronchietasis',
        label: 'Respiratory disorders - On confirmed diagnosis of bronchietasis',
        Category: 'Respiratory disorders - Bronchietasis',
    },
    {
        value: 'Respiratory disorders - On confirmed diagnosis of fibrosing alveolitis',
        label: 'Respiratory disorders - On confirmed diagnosis of fibrosing alveolitis',
        Category: 'Respiratory disorders - Fibrosing alveolitis',
    },
    {
        value: 'Respiratory disorders - On confirmed diagnosis of interstitial lung diseases',
        label: 'Respiratory disorders - On confirmed diagnosis of interstitial lung diseases',
        Category: 'Respiratory disorders - Interstitial lung diseases',
    },
    {
        value: 'Respiratory disorders - On confirmed diagnosis of pneumoconiosis',
        label: 'Respiratory disorders - On confirmed diagnosis of pneumoconiosis',
        Category: 'Respiratory disorders - Pneumoconiosis',
    },
    {
        value: 'Respiratory disorders - Other open lung surgery not for diagnostic purposes',
        label: 'Respiratory disorders - Other open lung surgery not for diagnostic purposes',
        Category: 'Respiratory disorders - Other open lung surgery not for diagnostic purposes',
    },
    {
        value: 'Respiratory disorders - Pulmonary emboli as seen on special investigations',
        label: 'Respiratory disorders - Pulmonary emboli as seen on special investigations',
        Category: 'Respiratory disorders - Pulmonary emboli as seen on special investigations',
    },
    {
        value:
            'Respiratory disorders - Recurrent pulmonary embolism despite optimal treatment with associated pulmonary hypertension (mean pulmonary artery pressure) > 40mmHg',
        label:
            'Respiratory disorders - Recurrent pulmonary embolism despite optimal treatment with associated pulmonary hypertension (mean pulmonary artery pressure) > 40mmHg',
        Category: 'Respiratory disorders - Recurrent pulmonary embolism',
    },
    {
        value: 'Respiratory disorders - Removal of a lung',
        label: 'Respiratory disorders - Removal of a lung',
        Category: 'Respiratory disorders - Removal of a lung',
    },
    {
        value: 'Respiratory disorders - Removal of one lobe of the lungs',
        label: 'Respiratory disorders - Removal of one lobe of the lungs',
        Category: 'Respiratory disorders - Removal of one lobe of the lungs',
    },
    {
        value:
            'Respiratory disorders - Status asthmaticus having undergone intubation and ICU admission',
        label:
            'Respiratory disorders - Status asthmaticus having undergone intubation and ICU admission',
        Category:
            'Respiratory disorders - Status asthmaticus having undergone intubation and ICU admission',
    },
    {
        value:
            'Rheumatoid arthritis - Musculoskeletal involvement having undergone surgery including joint replacement, joint reconstruction or joint fixation',
        label:
            'Rheumatoid arthritis - Musculoskeletal involvement having undergone surgery including joint replacement, joint reconstruction or joint fixation',
        Category:
            'Rheumatoid arthritis - Musculoskeletal involvement having undergone surgery including joint replacement joint reconstruction or joint fixation',
    },
    {
        value:
            'Rheumatoid arthritis - Progressive systemic involvement of the heart or lungs or vasculitis despite optimal therapy',
        label:
            'Rheumatoid arthritis - Progressive systemic involvement of the heart or lungs or vasculitis despite optimal therapy',
        Category:
            'Rheumatoid arthritis - Progressive systemic involvement of the heart or lungs or vasculitis despite optimal therapy',
    },
    {
        value:
            'Rheumatoid arthritis - Scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Rheumatoid arthritis - Scoring 1 major under either the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Rheumatoid arthritis - Rheumatoid arthritis resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Rheumatoid arthritis - Scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Rheumatoid arthritis - Scoring 1 moderate under both the Posture and Motion category and the Movement and Self Care category according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Rheumatoid arthritis - Rheumatoid arthritis resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage I',
        label: 'SCC: Squamous cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage I',
        label: 'SCC: Squamous cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage II',
        label: 'SCC: Squamous cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage II',
        label: 'SCC: Squamous cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage III',
        label: 'SCC: Squamous cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage III',
        label: 'SCC: Squamous cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage IV',
        label: 'SCC: Squamous cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage IV',
        label: 'SCC: Squamous cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'Skin cancer: Stage I',
        label: 'Skin cancer: Stage I',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage I',
        label: 'Skin cancer: Stage I',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage II',
        label: 'Skin cancer: Stage II',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage II',
        label: 'Skin cancer: Stage II',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage III',
        label: 'Skin cancer: Stage III',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage III',
        label: 'Skin cancer: Stage III',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage IV',
        label: 'Skin cancer: Stage IV',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage IV',
        label: 'Skin cancer: Stage IV',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value:
            'Speech disorders - Permanent aphasia (the inability of the brain to understand or express language)',
        label:
            'Speech disorders - Permanent aphasia (the inability of the brain to understand or express language)',
        Category: 'Speech disorders - Permanent aphasia',
    },
    {
        value:
            'Speech disorders - Permanent dysarthria (the inability to produce sounds so they can form comprehensive words)',
        label:
            'Speech disorders - Permanent dysarthria (the inability to produce sounds so they can form comprehensive words)',
        Category: 'Speech disorders - Permanent dysarthria',
    },
    {
        value: 'Stomach cancer: Stage I',
        label: 'Stomach cancer: Stage I',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage I',
        label: 'Stomach cancer: Stage I',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage II',
        label: 'Stomach cancer: Stage II',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage II',
        label: 'Stomach cancer: Stage II',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage III',
        label: 'Stomach cancer: Stage III',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage III',
        label: 'Stomach cancer: Stage III',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage IV',
        label: 'Stomach cancer: Stage IV',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage IV',
        label: 'Stomach cancer: Stage IV',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Testicular cancer: Stage I',
        label: 'Testicular cancer: Stage I',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage I',
        label: 'Testicular cancer: Stage I',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage II',
        label: 'Testicular cancer: Stage II',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage II',
        label: 'Testicular cancer: Stage II',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage III',
        label: 'Testicular cancer: Stage III',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage III',
        label: 'Testicular cancer: Stage III',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage IV',
        label: 'Testicular cancer: Stage IV',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage IV',
        label: 'Testicular cancer: Stage IV',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Thyroid cancer: Stage I',
        label: 'Thyroid cancer: Stage I',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage I',
        label: 'Thyroid cancer: Stage I',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage II',
        label: 'Thyroid cancer: Stage II',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage II',
        label: 'Thyroid cancer: Stage II',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage III',
        label: 'Thyroid cancer: Stage III',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage III',
        label: 'Thyroid cancer: Stage III',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage IV',
        label: 'Thyroid cancer: Stage IV',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage IV',
        label: 'Thyroid cancer: Stage IV',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Tongue cancer: Stage I',
        label: 'Tongue cancer: Stage I',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage I',
        label: 'Tongue cancer: Stage I',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage II',
        label: 'Tongue cancer: Stage II',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage II',
        label: 'Tongue cancer: Stage II',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage III',
        label: 'Tongue cancer: Stage III',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage III',
        label: 'Tongue cancer: Stage III',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage IV',
        label: 'Tongue cancer: Stage IV',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage IV',
        label: 'Tongue cancer: Stage IV',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Admittance to a recognised physical or mental rehabilitation institution for more than a continuous period of 30 days',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Admittance to a recognised physical or mental rehabilitation institution for more than a continuous period of 30 days',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Admittance to a recognised physical or mental rehabilitation institution',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Emergency tracheostomy or cricothyrotomy',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Emergency tracheostomy or cricothyrotomy',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Emergency tracheostomy or cricothyrotomy',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone a decompression laminectomy',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone a decompression laminectomy',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Decompression laminectomy',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone drainage via burrhole',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone drainage via burrhole',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Drainage via burrhole',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone major surgical reconstruction that was medically necessary for multiple facial fractures involving more than one anatomical area. This must be medically necessary and exclude elective cosmetic surgery',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone major surgical reconstruction that was medically necessary for multiple facial fractures involving more than one anatomical area. This must be medically necessary and exclude elective cosmetic surgery',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Major surgical reconstruction',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone spinal fusion',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Having undergone spinal fusion',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Spinal fusion',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Head injury having undergone emergency surgery craniotomy or drainage of cerebrospinal fluid',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Head injury having undergone emergency surgery craniotomy or drainage of cerebrospinal fluid',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Head injury',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - ICU admission with mechanical ventilation for at least 96 hours',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - ICU admission with mechanical ventilation for at least 96 hours',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - ICU admission with mechanical ventilation for at least 96 hours',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Le Fort II and III facial injuries',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Le Fort II and III facial injuries',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Le Fort II and III facial injuries',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Orbital fracture',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Orbital fracture',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Orbital fracture',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 1 major or 4 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 2 moderate or 1 moderate and 3 mild categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Scoring 3 moderate categories according to the Living Lifestyle Activities of Daily Living Table',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and resulting in permanent neurological deficit despite maximum medical improvement resulting in permanent inability to independently perform Activities of Daily Living',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Spinal injury resulting in paraplegia diplegia hemiplegia',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Spinal injury resulting in paraplegia diplegia hemiplegia',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Spinal injury resulting in paraplegia diplegia hemiplegia',
    },
    {
        value:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and the comatose state is persistent for longer than 96 hours',
        label:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and the comatose state is persistent for longer than 96 hours',
        Category:
            'Traumatic injuries including brain injuries head and neck injuries spinal injuries and coma - Traumatic injuries meeting the policy document description and the comatose state is persistent for longer than 96 hours',
    },
    {
        value: 'Urogenital disorders - Partial amputation of the penis',
        label: 'Urogenital disorders - Partial amputation of the penis',
        Category: 'Urogenital disorders - Partial amputation of the penis',
    },
    {
        value: 'Urogenital disorders - Partial cystectomy (removal of at least 50% of the bladder)',
        label: 'Urogenital disorders - Partial cystectomy (removal of at least 50% of the bladder)',
        Category:
            'Urogenital disorders - Partial cystectomy (removal of at least 50% of the bladder)',
    },
    {
        value:
            'Urogenital disorders - Radical cystectomy resulting in a need for an external bag or catheterisation',
        label:
            'Urogenital disorders - Radical cystectomy resulting in a need for an external bag or catheterisation',
        Category:
            'Urogenital disorders - Radical cystectomy resulting in a need for an external bag or catheterisation',
    },
    {
        value: 'Urogenital disorders - Total amputation of the penis',
        label: 'Urogenital disorders - Total amputation of the penis',
        Category: 'Urogenital disorders - Total amputation of the penis',
    },
    {
        value: 'Urogenital disorders - Unilateral or bilateral orchidectomy',
        label: 'Urogenital disorders - Unilateral or bilateral orchidectomy',
        Category: 'Urogenital disorders - Unilateral or bilateral orchidectomy',
    },
    {
        value: 'Urogenital disorders - Vesico-vaginal fistula having undergone surgery',
        label: 'Urogenital disorders - Vesico-vaginal fistula having undergone surgery',
        Category: 'Urogenital disorders - Vesicovaginal fistula having undergone surgery',
    },
    {
        value: 'Uterus cancer: Stage I',
        label: 'Uterus cancer: Stage I',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage I',
        label: 'Uterus cancer: Stage I',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage II',
        label: 'Uterus cancer: Stage II',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage II',
        label: 'Uterus cancer: Stage II',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage III',
        label: 'Uterus cancer: Stage III',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage III',
        label: 'Uterus cancer: Stage III',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage IV',
        label: 'Uterus cancer: Stage IV',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage IV',
        label: 'Uterus cancer: Stage IV',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Valvular and septal diseases of the heart - A heart transplant',
        label: 'Valvular and septal diseases of the heart - A heart transplant',
        Category: 'Valvular and septal diseases of the heart - Heart transplant',
    },
    {
        value:
            'Valvular and septal diseases of the heart - But still NYHA class 2 (or METS < 7) and EF < 55%',
        label:
            'Valvular and septal diseases of the heart - But still NYHA class 2 (or METS < 7) and EF < 55%',
        Category:
            'Valvular and septal diseases of the heart - Receiving optimal treatment (whether that is medical or surgical) for a valvular or septal heart disease',
    },
    {
        value:
            'Valvular and septal diseases of the heart - But still NYHA class 3 (or METS < 5) and EF < 50%',
        label:
            'Valvular and septal diseases of the heart - But still NYHA class 3 (or METS < 5) and EF < 50%',
        Category:
            'Valvular and septal diseases of the heart - Receiving optimal treatment (whether that is medical or surgical) for a valvular or septal heart disease',
    },
    {
        value:
            'Valvular and septal diseases of the heart - But still NYHA class 3 (or METS < 7) and EF < 55%',
        label:
            'Valvular and septal diseases of the heart - But still NYHA class 3 (or METS < 7) and EF < 55%',
        Category:
            'Valvular and septal diseases of the heart - Receiving optimal treatment (whether that is medical or surgical) for a valvular or septal heart disease',
    },
    {
        value:
            'Valvular and septal diseases of the heart - But still NYHA class 4 (or METS < 3) and EF < 40%',
        label:
            'Valvular and septal diseases of the heart - But still NYHA class 4 (or METS < 3) and EF < 40%',
        Category:
            'Valvular and septal diseases of the heart - Receiving optimal treatment (whether that is medical or surgical) for a valvular or septal heart disease',
    },
    {
        value:
            'Valvular and septal diseases of the heart - But still NYHA class 4 (or METS < 7) and EF < 55%',
        label:
            'Valvular and septal diseases of the heart - But still NYHA class 4 (or METS < 7) and EF < 55%',
        Category:
            'Valvular and septal diseases of the heart - Receiving optimal treatment (whether that is medical or surgical) for a valvular or septal heart disease',
    },
    {
        value:
            'Valvular and septal diseases of the heart - Endocarditis (as indicated by appropriate tests)',
        label:
            'Valvular and septal diseases of the heart - Endocarditis (as indicated by appropriate tests)',
        Category:
            'Valvular and septal diseases of the heart - Endocarditis (as indicated by appropriate tests)',
    },
    {
        value:
            'Valvular and septal diseases of the heart - Keyhole valvular surgery via the thoracic wall',
        label:
            'Valvular and septal diseases of the heart - Keyhole valvular surgery via the thoracic wall',
        Category:
            'Valvular and septal diseases of the heart - Keyhole valvular surgery via the thoracic wall',
    },
    {
        value:
            'Valvular and septal diseases of the heart - Open heart surgery for valvular conditions',
        label:
            'Valvular and septal diseases of the heart - Open heart surgery for valvular conditions',
        Category:
            'Valvular and septal diseases of the heart - Open heart surgery for valvular conditions',
    },
    {
        value:
            'Valvular and septal diseases of the heart - Surgical valvular procedure done endoscopically (including catheterbased procedures)',
        label:
            'Valvular and septal diseases of the heart - Surgical valvular procedure done endoscopically (including catheterbased procedures)',
        Category:
            'Valvular and septal diseases of the heart - Surgical valvular procedure done endoscopically (including catheterbased procedures)',
    },
    {
        value:
            'Valvular and septal diseases of the heart - Symptomatic atrial or ventricular septal defect having undergone surgical closure',
        label:
            'Valvular and septal diseases of the heart - Symptomatic atrial or ventricular septal defect having undergone surgical closure',
        Category:
            'Valvular and septal diseases of the heart - Symptomatic atrial or ventricular septal defect having undergone surgical closure',
    },
];
